import styled from '@emotion/styled'
import AntSpace from 'antd/lib/space'

export const Space = styled(AntSpace, {
  shouldForwardProp: (prop) => !['gap', 'hasWordWrap'].includes(prop)
})<{
  gap: number
  hasWordWrap?: boolean
}>`
  width: 100%;
  gap: ${({ gap }) => gap}px !important;

  .ant-space-item {
    width: 100%;
  }

  ${({ hasWordWrap }) =>
    hasWordWrap &&
    `
    .ant-space-item, .ant-radio-wrapper {
      height: 100%;
    }
  `}
`
